module.exports = __webpack_public_path__ + "static/react-c3ba82a536fe4983dad4c06b578dcd5d.png";